import { useState } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import { REFINEMENT_PROMPT_MAX_LENGTH } from 'utlis/constants';

const RefinementInput = ({ onSubmit, isSubmitting, disabled, stacked }) => {
  const [promptText, setPromptText] = useState('');

  const isOverLimit = promptText.length > REFINEMENT_PROMPT_MAX_LENGTH;
  const canSubmit = !isOverLimit && !isSubmitting && !disabled;

  const handleSubmit = () => {
    if (!canSubmit) {
      return;
    }

    onSubmit(promptText.trim());
    setPromptText('');
  };

  const handleKeyDown = e => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSubmit();
    }
  };

  return (
    <div className="flex flex-col">
      <div
        className={cn(
          stacked
            ? 'flex flex-col items-stretch gap-2 text-[12px]'
            : 'flex items-center justify-between gap-[16px] rounded-lg border border-[#E1E4E8]'
              + ' bg-[#F8F9FB] p-[4px] pl-[16px] text-[12px]'
        )}
      >
        <input
          type="text"
          className={cn(
            'text-[13px] font-normal leading-5',
            'placeholder:text-[13px] placeholder:font-normal placeholder:leading-5',
            'focus:outline-none disabled:cursor-not-allowed disabled:opacity-50',
            stacked
              ? 'w-full rounded-lg border border-[#E1E4E8] bg-white px-3 py-2.5 text-[#1F2937]'
                + ' placeholder:text-[#9CA3AF]'
              : 'flex-[4] bg-transparent text-[#606776] placeholder:text-[#606776]'
          )}
          placeholder="Change this..."
          value={promptText}
          onChange={e => setPromptText(e.target.value)}
          onKeyDown={handleKeyDown}
          maxLength={REFINEMENT_PROMPT_MAX_LENGTH + 1}
          disabled={isSubmitting || disabled}
        />
        <button
          type="button"
          className={cn(
            'flex items-center justify-center whitespace-nowrap rounded-lg transition-colors',
            'disabled:cursor-not-allowed disabled:opacity-50',
            stacked
              ? 'self-stretch border border-[#E1E4E8] bg-white px-3 py-2.5 font-medium leading-5'
                + ' text-[#1F2937] hover:bg-[#F9FAFB]'
              : 'bg-[#1B988E] px-3 py-2 text-[xs] font-medium leading-4 text-white hover:bg-[#17867d]'
          )}
          onClick={handleSubmit}
          disabled={!canSubmit}
        >
          {isSubmitting ? 'Generating…' : 'Generate variant'}
        </button>
      </div>
    </div>
  );
};

RefinementInput.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  isSubmitting: PropTypes.bool,
  disabled: PropTypes.bool,
  stacked: PropTypes.bool,
};

RefinementInput.defaultProps = {
  isSubmitting: false,
  disabled: false,
  stacked: false,
};

export default RefinementInput;
